import { render } from "./AddDocumentCategories.vue?vue&type=template&id=68dcce57"
import script from "./AddDocumentCategories.vue?vue&type=script&lang=ts"
export * from "./AddDocumentCategories.vue?vue&type=script&lang=ts"
script.render = render

export default script